import { render, staticRenderFns } from "./schoolLevel_table.vue?vue&type=template&id=0e2bad42&scoped=true&"
import script from "./schoolLevel_table.vue?vue&type=script&lang=js&"
export * from "./schoolLevel_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2bad42",
  null
  
)

export default component.exports